import { http } from "@/http/axios.js";

export const MENU_TYPE = [
  { name: "目录", value: 1 },
  { name: "菜单", value: 2 },
  { name: "按钮", value: 3 },
];

export function getDictEnumListAPI(dictCode) {
  return http({
    url: "/admin/sys/dictEnum/list",
    method: "get",
    params: { dictCode },
  }).then((res) => {
    return res.map((item) => {
      return {
        name: item.enumText,
        value: item.enumCode,
      };
    });
  });
}
export const stockType = [
  { name: "入库", value: 1 },
  { name: "出库", value: 2 },
];
export const genderDict = [
  { name: "男", value: 1 },
  { name: "女", value: 0 },
];
// 财务管理
export const searchTypeReport = [
  { name: "订单号", value: "orderNo" },
  { name: "交易单号", value: "openTradeNo" },
  { name: "客户姓名", value: "memberName" },
  { name: "客户手机号", value: "memberMobile" },
  { name: "商户名称", value: "merchantName" },
  { name: "审核人员", value: "reviewUserName" },
];
export const searchTypeCount = [
  { name: "订单号", value: "orderNo" },
  { name: "客户姓名", value: "memberName" },
  { name: "客户手机号", value: "memberMobile" },
  { name: "商户名称", value: "merchantName" },
];
export const amountType = [
  { name: "收入", value: 1 },
  { name: "支出", value: 2 },
];
// 审核管理
// 审核列表
export const searchTypeReview = [
  { name: "订单号", value: "orderNo" },
  { name: "客户姓名", value: "memberName" },
  { name: "客户手机号", value: "memberMobile" },
  { name: "审核人", value: "reviewUserName" },
  { name: "商户名称", value: "merchantName" },
];
export const searchTypeOrderRemark = [
  { name: "订单号", value: "orderNo" },
  { name: "客户姓名", value: "memberName" },
  { name: "跟进人", value: "traceUserName" },
];
export const reviewStatus = [
  { name: "全部", value: "0" },
  { name: "待提审", value: "1" },
  { name: "审核中", value: "2" },
];
// 审核明细--搜索
export const search_type_review_assign = [
  { name: "订单号", value: "orderNo" },
  { name: "客户名", value: "memberName" },
  { name: "手机号", value: "memberMobile" },
  { name: "审核", value: "reviewUserName" },
];
// 规则配置
export const dict_ruleType = [
  { name: "前置规则", value: 1 },
  { name: "弱规则", value: 2 },
  { name: "强规则", value: 3 },
];
// 运算符
export const dict_operator = [
  { name: "大于等于", value: "ge" },
  { name: "大于", value: "gt" },
  { name: "等于", value: "eq" },
  { name: "小于", value: "lt" },
  { name: "小于等于", value: "le" },
  { name: "介于", value: "between" },
];
export const dict_in_operator = [
  { name: "IN", value: "in" },
  { name: "IN & Start", value: "inStartWith" },
  { name: "IN & Contain", value: "inContain" },
];

// 订单管理相关
export const searchTypeOrder = [
  { name: "订单号", value: "orderNo" },
  { name: "审核", value: "reviewUserName" },
  { name: "客服", value: "kfUserName" },
  { name: "催收", value: "dcUserName" },
  { name: "客户姓名", value: "memberName" },
  { name: "客户手机号", value: "memberMobile" },
  { name: "客户身份证", value: "memberIdentityNo" },
  { name: "商户", value: "merchantName" },
  { name: "门店跟进人", value: "storeBusinessUserName" },
  { name: "设备串号", value: "deviceSn" },
];
// 订单管理相关
export const searchTypeOrderMall = [
  { name: "订单号", value: "orderNo" },
  { name: "审核人", value: "reviewUserName" },
  { name: "客户姓名", value: "memberName" },
  { name: "客户手机号", value: "memberMobile" },
  { name: "客户身份证", value: "memberIdentityNo" },
  { name: "商户", value: "merchantName" },
];
export const searchTypeBill = [
  { name: "订单号", value: "orderNo" },
  { name: "审核", value: "reviewUserName" },
  { name: "客服", value: "kfUserName" },
  { name: "催收", value: "dcUserName" },
  { name: "客户姓名", value: "memberName" },
  { name: "客户手机号", value: "memberMobile" },
  { name: "商户", value: "merchantName" },
];
export const orderStatus = [
  { name: "全部", value: "0" },
  { name: "审核中", value: "1" },
  { name: "待支付", value: "2" },
  { name: "待签章", value: "3" },
  { name: "待发货", value: "4" },
  { name: "待收货", value: "5" },
  { name: "租赁中", value: "6" },
  { name: "逾期中", value: "7" },
  { name: "待买断", value: "8" },
  { name: "待归还", value: "9" },
  { name: "已完成", value: "91" },
  { name: "已取消", value: "92" },
  { name: "已拒绝", value: "93" },
];
export const orderStatus2 = [
  { name: "审核中", value: "1" },
  { name: "待支付", value: "2" },
  { name: "待签章", value: "3" },
  { name: "待发货", value: "4" },
  { name: "待收货", value: "5" },
  { name: "租赁中", value: "6" },
  { name: "逾期中", value: "7" },
  { name: "待买断", value: "8" },
  { name: "待归还", value: "9" },
  { name: "已完成", value: "91" },
  { name: "已取消", value: "92" },
  { name: "已拒绝", value: "93" },
];
export const orderStatus3 = [
  { name: "租赁中", value: "6" },
  { name: "逾期中", value: "7" },
  { name: "待买断", value: "8" },
  { name: "待归还", value: "9" },
  { name: "已完成", value: "91" },
  { name: "已取消", value: "92" },
  { name: "已拒绝", value: "93" },
];
export const billStatus = [
  { name: "全部", value: "0" },
  { name: "待支付", value: "1" },
  { name: "已支付", value: "2" },
  { name: "已逾期", value: "3" },
  { name: "已取消", value: "4" },
];

export const dict_store_order_type = [
  { name: "门店订单", value: "2" },
  { name: "电车订单", value: "4" },
];
export const dict_mall_order_type = [
  { name: "普通订单", value: "1" },
];
export const dict_order_type = [
  { name: "普通订单", value: "1" },
  { name: "门店订单", value: "2" },
  { name: "电车订单", value: "4" },
];
export const memberType = [
  { name: "新客", value: "1" },
  { name: "在租", value: "2" },
];
export const dict_device_status = [
  { name: "在线", value: 1 },
  { name: "离线", value: 2 },
];
export const dict_store_type = [
  { name: "3C门店", value: 1 },
  { name: "电车门店", value: 2 },
];
